<template>
  <div class="exhibition-page">
    <AppHeader />

    <ExhibitionBanner />

    <FeaturedCarousel :items="featuredExhibitions" />

    <section class="exhibition-page__list-section">
      <h2 class="exhibition-page__list-heading">主题列表</h2>

      <div class="exhibition-page__inner">
        <div class="exhibition-page__content">
          <div v-if="loading" class="exhibition-page__loading">加载中...</div>
          <template v-else>
            <ExhibitionList
              ref="exhibitionListRef"
              :list="pagedList"
              :total="total"
              @search="handleSearch"
            />

            <div v-if="total" class="exhibition-page__pagination">
              <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="prev, pager, next"
                background
                @current-change="loadList"
              />
            </div>
          </template>
        </div>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import ExhibitionBanner from './components/ExhibitionBanner.vue'
import FeaturedCarousel from './components/FeaturedCarousel.vue'
import ExhibitionList from './components/ExhibitionList.vue'
import { fetchExhibitionList, mapExhibitionItem } from '@/api/exhibition'

export default {
  name: 'ExhibitionPage',
  components: {
    AppHeader,
    AppFooter,
    ExhibitionBanner,
    FeaturedCarousel,
    ExhibitionList
  },
  data() {
    return {
      featuredExhibitions: [],
      exhibitionList: [],
      searchKeyword: '',
      currentPage: 1,
      pageSize: 6,
      total: 0,
      loading: false
    }
  },
  computed: {
    pagedList() {
      return this.exhibitionList
    }
  },
  watch: {
    '$route.query.keyword'(value) {
      this.applyKeywordFromRoute(value)
    }
  },
  mounted() {
    document.documentElement.classList.add('hide-scrollbar')
    this.applyKeywordFromRoute(this.$route.query.keyword, true)
    this.loadFeatured()
  },
  activated() {
    document.documentElement.classList.add('hide-scrollbar')
  },
  deactivated() {
    document.documentElement.classList.remove('hide-scrollbar')
  },
  beforeDestroy() {
    document.documentElement.classList.remove('hide-scrollbar')
  },
  methods: {
    applyKeywordFromRoute(keyword, fetchOnEmpty = false) {
      const normalized = (keyword || '').trim()
      if (normalized) {
        this.$nextTick(() => {
          if (this.$refs.exhibitionListRef) {
            this.$refs.exhibitionListRef.setKeyword(normalized)
          }
        })
        this.handleSearch(normalized)
        return
      }
      if (fetchOnEmpty) {
        this.loadList()
      }
    },
    buildListParams() {
      return {
        page: this.currentPage,
        limit: this.pageSize,
        title: this.searchKeyword || undefined,
        status: '1,2'
      }
    },
    async loadList() {
      this.loading = true
      try {
        const { records, total } = await fetchExhibitionList(this.buildListParams())
        this.exhibitionList = records.map(mapExhibitionItem)
        this.total = total
      } catch (error) {
        console.error(error)
        this.exhibitionList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    async loadFeatured() {
      try {
        const { records } = await fetchExhibitionList({
          page: 1,
          limit: 5,
          status: '1,2',
          order: 'id',
          sort: 'desc'
        })
        this.featuredExhibitions = records.map(mapExhibitionItem)
      } catch (error) {
        console.error(error)
        this.featuredExhibitions = []
      }
    },
    handleSearch(keyword) {
      this.searchKeyword = keyword
      this.currentPage = 1
      this.loadList()
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibition-page {
  min-height: 100vh;
  background:
    url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E"),
    $color-paper;

  &__list-section {
    padding: 0 $content-padding $spacing-4xl;
  }

  &__list-heading {
    font-family: $font-serif;
    font-size: rem(24);
    font-weight: 700;
    color: $color-brown-dark;
    text-align: center;
    letter-spacing: 4px;
    margin-bottom: $spacing-xl;
  }

  &__inner {
    max-width: $container-max-width;
    margin: 0 auto;
  }

  &__content {
    width: 100%;
    min-width: 0;
  }

  &__loading {
    padding: $spacing-3xl;
    text-align: center;
    color: $color-text-light;
    background: $color-white;
    border-radius: 4px;
  }

  &__pagination {
    display: flex;
    justify-content: center;
    margin-top: $spacing-xl;
  }
}

</style>
